import { API_KEY, CLIENT_APP } from './clientConfig';
import { getAccessToken, getClientId, getUser } from './authService';

const API_BASE = 'https://dev.oliveeb.com/olreadia-service/api/v1';

function parseJwtPayload(token: string): any | null {
  try {
    const rawToken = token.startsWith('Bearer ') ? token.slice(7) : token;
    const payload = rawToken.split('.')[1];
    if (!payload) return null;
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(normalized.length + ((4 - normalized.length % 4) % 4), '=');
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
}

function getStoredActorId(token: string): string | null {
  const storedUser = getUser();
  if (storedUser?.id) return storedUser.id;

  const claims = parseJwtPayload(token);
  return claims?.sub || claims?.client_id || null;
}

export async function getUserBusinesses(): Promise<any[]> {
  const token = getAccessToken();
  if (!token) {
    console.warn('No access token found');
    return [];
  }
  const actorId = getStoredActorId(token);
  if (!actorId) {
    console.warn('No actor ID found for business lookup');
    return [];
  }
  const clientId = await getClientId();
  if (!clientId) {
    console.warn('No client ID found');
    return [];
  }
  try {
    const res = await fetch(`${API_BASE}/business-entities/user?page=0&size=100`, {
      headers: {
        'Authorization': token.startsWith('Bearer ') ? token : `Bearer ${token}`,
        'Content-Type': 'application/json',
        'O-CLIENT-APP': CLIENT_APP,
        'O-API-KEY': API_KEY,
        'O-CLIENT-ID': clientId,
        'O-ACTOR-ID': actorId,
      },
    });
    if (res.status === 401) {
      console.error('Unauthorized – token may have expired');
      return [];
    }
    if (res.ok) {
      const data = await res.json();
      return data.content || data;
    }
  } catch (e) {
    console.error('Failed to fetch businesses:', e);
  }
  return [];
}
